import React from 'react';
import { useParams } from 'react-router-dom';
import BadRequestPage from './BadRequestPage';
import UnauthorizedPage from './UnauthorizedPage';
import ForbiddenPage from './ForbiddenPage';
import NotFoundPage from './NotFoundPage';
import MethodNotAllowedPage from './MethodNotAllowedPage';
import RequestTimeoutPage from './RequestTimeoutPage';
import InternalServerErrorPage from './InternalServerErrorPage';
import NotImplementedPage from './NotImplementedPage';
import BadGatewayPage from './BadGatewayPage';
import ServiceUnavailablePage from './ServiceUnavailablePage';
import GatewayTimeoutPage from './GatewayTimeoutPage';
import '../assets/styles/errorpages.css'; 

const ErrorHandler = () => {
  const { errorCode } = useParams();

  switch (errorCode) {
    case '400':
      return <BadRequestPage />;
    case '401':
      return <UnauthorizedPage />;
    case '403':
      return <ForbiddenPage />;
    case '404':
      return <NotFoundPage />;
    case '405':
      return <MethodNotAllowedPage />;
    case '408':
      return <RequestTimeoutPage />;
    case '500':
      return <InternalServerErrorPage />;
    case '501':
      return <NotImplementedPage />;
    case '502':
      return <BadGatewayPage />;
    case '503':
      return <ServiceUnavailablePage />;
    case '504':
      return <GatewayTimeoutPage />;
    default:
      return <NotFoundPage />; 
  }
};

export default ErrorHandler;
